<div
  mat-dialog-title
  fxLayout="row"
  fxLayoutAlign="space-between start"
  id="alertDialogHeader"
>
  <h4
    data-test-id="lblAlertDialogHeader"
    class="m-0"
    aria-label="Alert header"
    tabindex="0"
  >
    {{ data.title }}
  </h4>
</div>

<mat-divider class="divider-spacer"></mat-divider>
<mat-dialog-content
  aria-labelledby="matAlertModalHeading"
  data-test-id="contmatAlertModal"
>
  <p>{{ data.idleState }}</p>
</mat-dialog-content>
<mat-divider class="divider-spacer"></mat-divider>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="1rem">
  <button
    *ngIf="!data.isTimeOut"
    mat-raised-button
    cg-mat-btn-type="primary"
    class="btn-medium"
    (click)="dataReset()"
  >
    STAY LOGGED IN
  </button>
  <button
    mat-raised-button
    cg-mat-btn-type="primary"
    class="btn-medium btn-bold-text"
    aria-label="click to cancel"
    (click)="logOut(data?.isTimeOut)"
  >
    {{ data.isTimeOut == true ? 'Ok' : ('Log out' | uppercase) }}
  </button>
</mat-dialog-actions>
